import { resolveImageUrl } from "../lib/api";
import RichText from "./RichText";

const BG = {
  default: "bg-[color:var(--tr-bg)]",
  soft: "bg-[color:var(--tr-bg-2)]",
  dark: "tr-dark",
};

export default function CustomSection({ section, index = 0 }) {
  if (!section) return null;
  const img = resolveImageUrl(section.image);
  const layout = section.layout || (index % 2 === 1 ? "text_image" : "image_text");
  const bg = BG[section.background] || BG.default;
  const isDark = section.background === "dark";
  const textColor = isDark ? "#F8F7F4" : "#1A1918";
  const subColor = isDark ? "rgba(248,247,244,0.7)" : "#5C5A56";

  const Title = section.title ? (
    <h2
      className="font-display font-light text-4xl sm:text-5xl lg:text-6xl tracking-tighter leading-[1]"
      style={{ color: textColor }}
    >
      {section.title}
    </h2>
  ) : null;

  const Body = section.body ? (
    <RichText
      value={section.body}
      className="font-body text-lg leading-relaxed mt-8 max-w-xl"
      style={{ color: subColor }}
    />
  ) : null;

  const Image = img ? (
    <div className="tr-img-wrap aspect-[4/5] w-full">
      <img src={img} alt={section.title || ""} />
    </div>
  ) : (
    <div className="aspect-[4/5] w-full bg-[color:var(--tr-bg-2)]" />
  );

  // Layouts
  if (layout === "text_only") {
    return (
      <section data-testid={`custom-section-${section.id}`} className={`${bg} px-6 sm:px-12 py-24 sm:py-32`}>
        <div className="max-w-3xl mx-auto">
          {Title}
          {Body}
        </div>
      </section>
    );
  }

  if (layout === "text_centered") {
    return (
      <section data-testid={`custom-section-${section.id}`} className={`${bg} px-6 sm:px-12 py-24 sm:py-32`}>
        <div className="max-w-3xl mx-auto text-center">
          {section.title && (
            <h2
              className="font-display font-light text-4xl sm:text-5xl lg:text-6xl tracking-tighter leading-[1]"
              style={{ color: textColor }}
            >
              {section.title}
            </h2>
          )}
          {section.body && (
            <RichText
              value={section.body}
              className="font-body text-lg leading-relaxed mt-8 mx-auto max-w-2xl"
              style={{ color: subColor }}
            />
          )}
        </div>
      </section>
    );
  }

  if (layout === "image_only") {
    return (
      <section data-testid={`custom-section-${section.id}`} className={`${bg} px-6 sm:px-12 py-24 sm:py-32`}>
        <div className="max-w-6xl mx-auto">
          {img ? (
            <div className="tr-img-wrap aspect-[16/9] w-full">
              <img src={img} alt={section.title || ""} />
            </div>
          ) : (
            <div className="aspect-[16/9] w-full bg-[color:var(--tr-bg-2)]" />
          )}
        </div>
      </section>
    );
  }

  const reverse = layout === "text_image";

  return (
    <section data-testid={`custom-section-${section.id}`} className={`${bg} px-6 sm:px-12 py-24 sm:py-32`}>
      <div className="max-w-7xl mx-auto grid grid-cols-12 gap-8 items-center">
        <div className={`col-span-12 md:col-span-6 ${reverse ? "md:order-2" : ""}`}>
          {Image}
        </div>
        <div className={`col-span-12 md:col-span-6 ${reverse ? "md:order-1" : ""}`}>
          {Title}
          {Body}
        </div>
      </div>
    </section>
  );
}
